<template>
    <div>
        <el-menu :default-active="defaultActive" router unique-opened class="layout-aside" :collapse="isCollapse">
            <div class="collapse">
                <span class="el-icon-d-arrow-left" v-if="!isCollapse" @click=" isCollapse = true"></span>
                <span class="el-icon-d-arrow-right" v-else @click=" isCollapse = false"></span>
            </div>
            <el-submenu :index="item.path" v-for="(item,index) in routeList" :key="index">
                <template slot="title">
                    <i :class="['fonticon',item.meta.iconClass]"></i>
                    <span>{{item.meta.name}}</span>
                </template>
                <el-menu-item :index="subitem.path" v-for="(subitem,subindex) in item.children" :key="subindex">{{subitem.meta.name}}</el-menu-item>
            </el-submenu>
            <!-- <el-submenu :index="item.path" v-for="(item,index) in routeList" :key="index" v-if="item.meta">
                <template slot="title">
                    <i :class="['fonticon',item.meta.iconClass]"></i>
                    <span>{{item.meta.name}}</span>
                </template>
                <el-menu-item :index="subitem.path" v-for="(subitem,subindex) in item.children" :key="subindex" v-if="subitem.name != 'site-edit' ">{{subitem.meta.name}}</el-menu-item>
            </el-submenu> -->
            <!-- <el-submenu index="/home">
                <template slot="title">
                    <i class="fonticon">&#xe635;</i>
                    <span>主页</span>
                </template>
                <el-menu-item index="/home/dashboard">经营概况</el-menu-item>
                <el-menu-item index="/home/monitoring">数据监控</el-menu-item>
                <el-menu-item index="1-3">工作台</el-menu-item>
            </el-submenu>
            <el-submenu index="/financial">
                <template slot="title">
                    <i class="fonticon">&#xe623;</i>
                    <span>财务管理</span>
                </template>
                <el-menu-item index="/financial/cashWater">门店流水</el-menu-item>
                <el-menu-item index="/financial/partnerRecharge">快递员充值记录</el-menu-item>
                <el-menu-item index="/financial/smsRecharge">短信充值记录</el-menu-item>
                <el-menu-item index="/financial/analyze">财务月报</el-menu-item>
                <el-menu-item index="/financial/analyzeDay">经营日报</el-menu-item>
            </el-submenu>
            <el-submenu index="/basis">
                <template slot="title">
                    <i class="fonticon">&#xe687;</i>
                    <span>基础业务</span>
                </template>
                <el-menu-item index="/basis/delivery">派件管理</el-menu-item>
                <el-menu-item index="/basis/mail">寄件管理</el-menu-item>
                <el-menu-item index="/basis/sms">短信发送管理</el-menu-item>
                <el-menu-item index="/basis/shelves">货架管理</el-menu-item>
            </el-submenu>
            <el-submenu index="4">
                <template slot="title">
                    <i class="fonticon">&#xe61d;</i>
                    <span>广告管理</span>
                </template>
                <el-menu-item index="4-0">添加投放</el-menu-item>
                <el-menu-item index="4-1">投放列表</el-menu-item>
                <el-menu-item index="4-2">投放报表</el-menu-item>
            </el-submenu>
            <el-submenu index="/site">
                <template slot="title">
                    <i class="fonticon">&#xe7d6;</i>
                    <span>网点管理</span>
                </template>
                <el-menu-item index="/site/list">网点列表</el-menu-item>
                <el-menu-item index="/site/map">网点分布地图</el-menu-item>
                <el-menu-item index="/site/add">添加网点</el-menu-item>
            </el-submenu>
            <el-submenu index="/user">
                <template slot="title">
                    <i class="fonticon">&#xe63b;</i>
                    <span>用户管理</span>
                </template>
                <el-menu-item index="/user/add">添加用户</el-menu-item>
                <el-menu-item index="/user/list">用户列表</el-menu-item>
                <el-menu-item index="/user/partner">快递员列表</el-menu-item>
            </el-submenu>
            <el-submenu index="/customer">
                <template slot="title">
                    <i class="fonticon">&#xe617;</i>
                    <span>客户管理</span>
                </template>
                <el-menu-item index="7-0">客户留言</el-menu-item>
                <el-menu-item index="/customer/list">客户列表</el-menu-item>
                <el-menu-item index="7-2">客户分析</el-menu-item>
            </el-submenu> -->
        </el-menu>
    </div>
</template> 
<script>
    export default {
        data() {
            return {
               isCollapse: false
            }
        },
        computed: {
            defaultActive(){
                const route = this.$route.path.split('/')[1]+'/'+this.$route.path.split('/')[2]
                return '/' + route
            },
            routeList() {
                const router = this.$router.options.routes;
                return router.filter(item => item.meta && item.meta.inframe);
            },
        },
        created() {
        }
    }
</script>
<style lang="less" scoped>
    .layout-aside{
        height: 100%;
        background: #fff;
        width: 200px;
    }
    .el-menu--collapse{
        width: 60px;
    }
    .el-menu-item.is-active{
        background: rgba(0,121,242,.06);
        border-radius: 0;
        border-right: 3px solid #0079f2;
    }
    .fonticon{
        width: 30px;
        display: inline-block;
        font-size: 16px;
        color: #333;
    }
    .collapse{
        display: flex;
        justify-content: center;
        height: 46px;
        align-items: center;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
    }
</style>

